module.exports = __webpack_public_path__ + "img/projects-catalog.a02a788f.webp";